import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
    selector: '[appTextareaAutoresize]',
    standalone: false
})
export class TextareaAutoresizeDirective implements OnInit {
  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    if (this.elementRef.nativeElement.scrollHeight) {
      setTimeout(() => this.resize());
    }
  }

  @HostListener(':input')
  onInput() {
    this.resize();
  }

  resize() {
    this.elementRef.nativeElement.style.height = 0;
    this.elementRef.nativeElement.style.height = this.elementRef.nativeElement.scrollHeight + 'px';
  }
}
